import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Search from "@insite/mobius/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(searchInputStyles, {
    ...searchInputStyles,
    input: {
        sizeVariant: "default",
        iconProps: {
            src: Search,
            color: `${CarotekColors.white}`,
            css: css`
                svg {
                    stroke-width: 3;
                }
            `,
        },
        border: "underline",
        cssOverrides: {
            formField: css`
                width: 220px;

                button[class^="StyledButton"] {
                    background-color: ${getColor("primary")};
                    height: 37.8px;
                }
            `,
            inputSelect: css`
                border: 1px solid ${CarotekColors.grey3};
                height: 37.8px;
                font-size: 14px;
                :focus {
                    border: 1px solid ${CarotekColors.grey3};
                }
            `,
        },
    },
});
